import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Button } from '@/components/ui/button';
import { HelpCircle } from 'lucide-react';

interface VoiceTooltipProps {
  name: string;
  avatarUrl?: string;
  onClick: () => void;
}

export function VoiceTooltip({ name, avatarUrl, onClick }: VoiceTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button 
            variant="ghost" 
            size="sm" 
            className="h-6 w-6 p-0"
            onClick={(e) => {
              e.stopPropagation();
              onClick();
            }}
          >
            <HelpCircle className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="top">
          <p className="text-sm">Click to meet {name.split(' ')[0]}!</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
